import { render, staticRenderFns } from "./successCases.vue?vue&type=template&id=dd4dd2a0&scoped=true"
import script from "./successCases.vue?vue&type=script&lang=js"
export * from "./successCases.vue?vue&type=script&lang=js"
import style0 from "./successCases.vue?vue&type=style&index=0&id=dd4dd2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4dd2a0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSucessdemo: require('/juude-website-view/components/common-sucessdemo.vue').default})
